export enum ClientDetailsTabs {
  Client = 'client',
  Partner = 'partner',
}
